/**
 * im指令集合
 * Bai.Zhiming
 * 2019-7-31
 */
angular.module('IMDirectiveModule', [
    'contextmenuModule',
    'imLoadersModule',
    'imResizerModule',
    'tencentImModule'
]);
